import { Box, Button, ControllerModal, DialogContent } from '@bymason-private/legacy-pattern-components';

interface TimeoutModalProps {
  open: boolean;
  onClose: () => void;
}

export function TimeoutModal({ onClose, open }: TimeoutModalProps) {
  const handleClose = () => {
    onClose();
  };

  return (
    <ControllerModal
      onClose={handleClose}
      open={open}
      subTitle='Please re-launch the session if you would like to continue.'
      title='The session has timed out due to inactivity'
    >
      <DialogContent sx={{ maxWidth: '30vw', minWidth: 480 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: 2,
            marginTop: 7,
          }}
        >
          <Button color='primary' onClick={handleClose} size='medium' variant='contained'>
            Close
          </Button>
        </Box>
      </DialogContent>
    </ControllerModal>
  );
}
